export enum AllocationTypeEnum {
    Amount = 'amount',
    Percentage = 'percent',
}